// extracted by mini-css-extract-plugin
export default {"workSpace":"workSpace_workSpace__iHt4y"};